module.exports = __webpack_public_path__ + "static/media/Girls-Bed3.289e50ab.webp";